export default __webpack_public_path__ + "static/media/1.fda485e1.svg";